import React, { useEffect } from "react";
import { req } from "../utils";


export default function Debug() {
  return       <main className="bc-page--content"><h3>Debugging page</h3></main>;
}